import { Type } from '@angular/core';

export class AddDynamicAnwsers {
    constructor(
        public component: Type<any>,
        public questionDefintion: any,
        public func: any
    ) {}
}
